'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyRepInfo = undefined;

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _fetchOwners = require('ui-addon-upgrades/_core/common/api/fetchOwners');

var _RepTypes = require('ui-addon-upgrades/_core/common/constants/RepTypes');

var PROPERTY_KEY = 'repInfo';

var getPropertyRepInfo = exports.getPropertyRepInfo = function getPropertyRepInfo(upgradeData, upgradeSource, props) {
  if (props.allowModal === false) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, {});
  }

  return (0, _fetchOwners.fetchOwners)().then(function (ownerInfo) {
    var owner = null;
    if (ownerInfo.MARKETING_SALES && ownerInfo.MARKETING_SALES.link) {
      owner = ownerInfo.MARKETING_SALES;
      owner.type = _RepTypes.MARKETING_SALES;
    } else if (ownerInfo.IGS_NURTURING && ownerInfo.IGS_NURTURING.link) {
      owner = ownerInfo.IGS_NURTURING;
      owner.type = _RepTypes.IGS_NURTURING;
    }

    return (0, _createProperty.createProperty)(PROPERTY_KEY, owner);
  }).catch(function () {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, {});
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyRepInfo.js
// module id = 470
// module chunks = 3 4 5